import m, {Vnode} from "mithril";
import {TInterviewGoalAttachment} from "../model/TInterviewThread";

function displayName(attachment: TInterviewGoalAttachment): string {
    return attachment.label ?? attachment.filename ?? attachment.url ?? "";
}

function openLink(attachment: TInterviewGoalAttachment): Vnode|null {
    if (!attachment.openUrl) {
        return null;
    }

    return m("a.interview-goal-attachment-open.interview-goal-attachment-name", {
        href: attachment.openUrl,
        target: "_blank",
        rel: "noopener noreferrer",
    }, displayName(attachment));
}

export function renderInterviewGoalAttachment(
    attachment: TInterviewGoalAttachment,
    galleryId?: string,
): Vnode {
    const name = displayName(attachment);
    switch (attachment.type) {
        case "image":
            return m(".interview-goal-attachment.interview-goal-attachment-image", [
                m(".lightbox.interview-goal-attachment-image-thumbnail", [
                    m("a", {
                        href: attachment.renderUrl,
                        "data-lightbox-gallery": galleryId,
                        "aria-label": name,
                    }, [
                        m("img", {
                            src: attachment.renderUrl,
                            alt: name,
                            title: name,
                            loading: "lazy",
                        }),
                    ]),
                ]),
            ]);
        case "audio":
            return m(".interview-goal-attachment.interview-goal-attachment-audio", [
                attachment.label ? m(".interview-goal-attachment-label", attachment.label) : null,
                m("audio", {controls: true, preload: "metadata"}, [
                    m("source", {src: attachment.renderUrl}),
                    name,
                ]),
            ]);
        case "video":
            return m(".interview-goal-attachment.interview-goal-attachment-video", [
                attachment.label ? m(".interview-goal-attachment-label", attachment.label) : null,
                m(".interview-goal-attachment-video-player", [
                    m("video", {controls: true, playsinline: true, preload: "metadata"}, [
                        m("source", {src: attachment.renderUrl}),
                        name,
                    ]),
                ]),
            ]);
        case "document":
            return m(".interview-goal-attachment.interview-goal-attachment-document", [
                m("i.bi.bi-file-earmark-text"),
                openLink(attachment),
            ]);
        case "link":
            return m(".interview-goal-attachment.interview-goal-attachment-link", [
                m("i.bi.bi-link-45deg"),
                m("a.interview-goal-attachment-name", {
                    href: attachment.url,
                    target: "_blank",
                    rel: "noopener noreferrer",
                }, name || attachment.url),
            ]);
    }

    return m(".interview-goal-attachment", name);
}

export function renderInterviewGoalAttachmentGallery(
    attachments: TInterviewGoalAttachment[],
    galleryId: string,
): Vnode {
    return m(".interview-goal-attachment-gallery", attachments.map(attachment =>
        m("figure.interview-goal-attachment-gallery-item", [
            renderInterviewGoalAttachment(attachment, galleryId),
            m("figcaption.interview-goal-attachment-gallery-caption", displayName(attachment)),
        ]),
    ));
}
